import { Box, Button, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

type AddConditionButtonProps = {
	label: string;
	onClick: () => void;
};

const AddConditionButton = ({ label, onClick }: AddConditionButtonProps) => {
	return (
		<Button
			onClick={onClick}
			disableElevation
			variant="text"
			sx={{
				width: "100%",
				borderRadius: "16px",
				textTransform: "none",
				justifyContent: "center",
				backgroundColor: "#FFFFFF",
				border: "1px solid #0195D5",
				boxShadow: "0px 2px 6px rgba(15, 23, 42, 0.08)",
				paddingY: 1.5,
				paddingX: 2,
				"&:hover": {
					backgroundColor: "#0195D51A",
					borderColor: "#0195D5",
					boxShadow: "0px 4px 12px rgba(15, 23, 42, 0.12)",
				},
			}}
		>
			<Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center">
				<Typography
					component="span"
					variant="body1"
					sx={{ color: "#0195D5", fontWeight: 600, letterSpacing: "0.01em" }}
				>
					{label}
				</Typography>
			</Stack>
		</Button>
	);
};

export default AddConditionButton;
